<script>
import BayOnDeck from '@/view/pages/vesselProfile/components/BayOnDeck.vue'
import BayUnderDeck from '@/view/pages/vesselProfile/components/BayUnderDeck.vue'
import HatchCover from '@/components/HatchCover.vue'
import { mapGetters, mapActions, mapState } from 'vuex'


export default {


    props: {
        name: {
            type: Number,
            default: 1
        },
        selectedContainerType: {
            default: 'standard'
        },
        mirrorMode: {
            default: false
        },
        data: {
            default: {
                minHoldTiers: 0,
                minDeckTiers: 0,
                onDeck: {
                    cols: 4,
                    rows: 4,
                    cells: [{ existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }],
                },
                underDeck: {
                    cols: 4,
                    rows: 4,
                    cells: [{ existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false }],
                }
            }
        },
        rel: {
            default: ''
        },
    },
    data() {
        return {
            ShowHatchCover: true
        }
    },
    methods: {
        toggleMirror() {
            this.isMirrored = !this.isMirrored
        },
        toggleShowHatchCover() {
            this.$store.dispatch('setShowHatchCover', {})
        }
    },
    computed: {
        ...mapGetters({
            selectedHatchData: 'getSelectedHatchData'
        }),
        selectedHatchDatas() {
            return this.selectedHatchData;
        },
        isBayMirrored: {
            get() {
                return this.$store.state.vesselProfile.mirroredBays[this.rel]
            },
            set() {
                this.isMirrored = !this.isMirrored
                this.$store.dispatch('setMirroredBays', { [this.rel]: this.isMirrored })
                return this.isMirrored
            }
        },
    },
    components: {
        BayOnDeck,
        BayUnderDeck,
        HatchCover
    },
}

</script>

<template>
    <main class="">
        <div>
            <v-checkbox hide-details dense color='gray' class='d-flex align-items-center' label='Mirror'
                v-model="isBayMirrored"></v-checkbox>
        </div>
        <div class="d-grid justify-content-center gap-3  ">
            <div class="bay-view col-smflex justify-content-center p-1 py-5"
                :style="{ borderColor: '#A0A0A0', borderWidth: '1px', borderStyle: 'solid', borderRadius: '5px' }">
                <b-button class="ml-2" size="sm" variant="outline-dark" @click="toggleShowHatchCover">
                    Hatch Cover
                </b-button>
                <h3 class="text-center">Bay {{ String(name).padStart(2, '0') }}</h3>


                <bay-on-deck style="justify-items: center;" :cellSize=20 :rel="this.rel" :data="data.onDeck"
                    :minDeckTiers="data.minDeckTiers" :mirrorMode="mirrorMode"
                    :selectedContainerType="selectedContainerType" />
                <HatchCover style="justify-items: center;" ref="hatchCoverComponent" :cellSize="5"
                    :vesselProfileHatchCovers="this.selectedHatchDatas.vesselProfileHatchCovers"
                    :cellsCount="this.selectedHatchDatas.cellsCount" v-if="this.selectedHatchData.cellsCount" />

                <bay-under-deck style="justify-items: center;" :cellSize=20 :rel="this.rel" :data="data.underDeck"
                    :minHoldTiers="data.minHoldTiers" :mirrorMode="mirrorMode"
                    :selectedContainerType="selectedContainerType" />
            </div>
        </div>
    </main>
</template>

<style scoped></style>